import script from "./TboPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TboPage.vue?vue&type=script&setup=true&lang=ts"

import "./TboPage.vue?vue&type=style&index=0&id=bd2c69d8&lang=scss"

const __exports__ = script;

export default __exports__